var map = {
	"./additionalInfoIcon.svg": 620,
	"./arrowLeftIcon.svg": 621,
	"./arrowMediumTop.svg": 622,
	"./arrowRightIcon.svg": 623,
	"./arrowRightIconSharp.svg": 624,
	"./arrowRightSmallIcon.svg": 625,
	"./arrowScalableIcon.svg": 626,
	"./arrowSelect2.svg": 627,
	"./arrowSelectIcon.svg": 628,
	"./benefit1.svg": 629,
	"./benefit2.svg": 630,
	"./benefit3.svg": 631,
	"./cardsIcon.svg": 632,
	"./checkCirсleIcon.svg": 633,
	"./circleInfoIcon.svg": 634,
	"./copyIcon copy.svg": 635,
	"./copyIcon.svg": 636,
	"./crossIcon.svg": 637,
	"./crossIcon2.svg": 638,
	"./crossIcon3.svg": 639,
	"./crossIconSmall.svg": 640,
	"./crossSmallIcon.svg": 641,
	"./defaultCategoryIcon.svg": 642,
	"./depNumberIcon.svg": 643,
	"./elfCentralIcon.svg": 644,
	"./equalitySign.svg": 645,
	"./errorIcon.svg": 646,
	"./eyeClosedIcon.svg": 647,
	"./eyeOpenIcon.svg": 648,
	"./favoritesIcon.svg": 649,
	"./favoritesLabelIcon.svg": 650,
	"./filterDivider.svg": 651,
	"./filterIcon.svg": 652,
	"./frequencyIcon.svg": 653,
	"./fsAmountIcon.svg": 654,
	"./fullScreenIcon.svg": 655,
	"./gameIcon.svg": 656,
	"./goldGiftIcon.svg": 657,
	"./hamburgerIcon.svg": 658,
	"./infoIcon.svg": 659,
	"./infoSymbol.svg": 660,
	"./levelBackground.svg": 661,
	"./levelBackgroundNew.svg": 662,
	"./linkIcon.svg": 663,
	"./lockIcon.svg": 664,
	"./lockSharpIcon.svg": 665,
	"./maxBonusAmountIcon.svg": 666,
	"./maxWinFsIcon.svg": 667,
	"./menu/fortuneIcon.svg": 384,
	"./menu/fortuneIconL.svg": 385,
	"./menu/helpdeskIcon.svg": 386,
	"./menu/helpdeskIconL.svg": 387,
	"./menu/homeIcon.svg": 388,
	"./menu/homeIconLarge.svg": 389,
	"./menu/jackpotIcon.svg": 390,
	"./menu/logo.svg": 391,
	"./menu/logoSmall.svg": 392,
	"./menu/loyaltyIcon.svg": 393,
	"./menu/mobileAppIcon.svg": 394,
	"./menu/profileIcon.svg": 395,
	"./menu/questIcon.svg": 396,
	"./menu/questsIcon.svg": 397,
	"./menu/rewardLineupIcon.svg": 398,
	"./menu/searchIcon.svg": 399,
	"./menu/searchIconLarge.svg": 400,
	"./menu/signOutIcon.svg": 401,
	"./menu/star.svg": 402,
	"./menu/tournamentIcon.svg": 403,
	"./menu/tournamentLargeIcon.svg": 404,
	"./menu/vipIcon.svg": 405,
	"./menu/wheelIcon.svg": 406,
	"./menu/wheelIconL.svg": 407,
	"./menu/wheelIconMobile.svg": 408,
	"./menuIcon.svg": 668,
	"./minDepIcon.svg": 669,
	"./noTournamentIcon.svg": 670,
	"./numbers/number-1.svg": 409,
	"./numbers/number-2.svg": 410,
	"./numbers/number-3.svg": 411,
	"./numbers/number-4.svg": 412,
	"./numbers/number-5.svg": 413,
	"./numbers/number-6.svg": 414,
	"./numbers/number-7.svg": 415,
	"./numbers/number-8.svg": 416,
	"./numbers/number-9.svg": 417,
	"./numbers/number-shine-1.svg": 418,
	"./numbers/number-shine-2.svg": 419,
	"./numbers/number-shine-3.svg": 420,
	"./numbers/number-shine-4.svg": 421,
	"./numbers/number-shine-5.svg": 422,
	"./numbers/number-shine-6.svg": 423,
	"./numbers/number-shine-7.svg": 424,
	"./numbers/number-shine-8.svg": 425,
	"./numbers/number-shine-9.svg": 426,
	"./playIcon.svg": 671,
	"./polygon.svg": 672,
	"./preloaderDotsAnimation.svg": 673,
	"./preloaderSpinnerAnimation.svg": 674,
	"./presentIcon.svg": 675,
	"./promoIcon.svg": 676,
	"./recentIcon.svg": 677,
	"./search2Icon.svg": 678,
	"./search3Icon.svg": 679,
	"./sharpTickIcon copy.svg": 680,
	"./sharpTickIcon.svg": 681,
	"./smallInfoSymbol.svg": 682,
	"./smoothArrowIcon.svg": 683,
	"./successIcon.svg": 684,
	"./supportIcon.svg": 685,
	"./tag1Icon.svg": 686,
	"./tag2Icon.svg": 687,
	"./tag3Icon.svg": 688,
	"./tag4Icon.svg": 689,
	"./tickIcon.svg": 690,
	"./unverified.svg": 691,
	"./verified.svg": 692,
	"./wagerIcon.svg": 693,
	"./wagerTimeIcon.svg": 694,
	"./warningIcon.svg": 695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;